import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { errMsg, useApi } from "@/lib/api";

const LABELS = {
  bdq_tahap: "BDQ (setiap tahap)", skda: "SKDA (larian penuh)", hte: "HTE (jana)", kbm: "KBM (jana)", adab: "ADAB (kajian)",
  adab_ppt: "ADAB PPT (bina dek, tambahan)", laras: "Tweak mana-mana bahagian", cari: "Carian calon ayat", export: "Eksport (PDF/DOCX/PPTX)",
};

export const QuotaWeights = () => {
  const api = useApi();
  const [w, setW] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api("get", "/admin/settings/quota-weights").then((r) => setW(r.quota_weights)).catch(() => {}); }, [api]);
  const save = async () => {
    setSaving(true);
    try { setW((await api("put", "/admin/settings/quota-weights", { quota_weights: w })).quota_weights); toast.success("Pemberat kuota disimpan"); }
    catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  };
  if (!w) return <Loader2 className="animate-spin text-q" />;
  return (
    <div className="max-w-lg space-y-3" data-testid="quota-weights">
      {Object.keys(LABELS).map((k) => (
        <label key={k} className="flex items-center justify-between gap-4 border-b border-line py-2">
          <span className="text-sm">{LABELS[k]}</span>
          <input type="number" step="0.5" min="0" value={w[k]} onChange={(e) => setW({ ...w, [k]: Number(e.target.value) })} data-testid={`quota-weight-${k}`}
            className="w-24 h-9 px-3 rounded-lg bg-bg border border-line text-sm font-mono-data text-right" />
        </label>
      ))}
      <button onClick={save} disabled={saving} data-testid="quota-weights-save"
        className="h-11 px-6 rounded-full bg-ink text-bg text-sm font-semibold inline-flex items-center gap-2 disabled:opacity-40">
        {saving ? <Loader2 size={15} className="animate-spin" /> : <Save size={15} />} Simpan pemberat
      </button>
    </div>
  );
};
